import { useEffect, useMemo, useState } from "react";
import { listPayPeriods } from "../../Moduels/payroll/payrollApi";
import { periodStatusBadge } from "../../Moduels/payroll/payrollRunUtils";
import SearchableSelect from "./SearchableSelect";

export function formatPayPeriodLabel(period) {
  if (!period) return "";
  if (period.period_label) return period.period_label;
  if (period.start_date && period.end_date) {
    return `${period.start_date} → ${period.end_date}`;
  }
  return String(period.pay_period_id || "");
}

function periodGroup(period) {
  const d = period?.start_date || period?.end_date;
  if (!d) return "Other";
  const year = String(d).slice(0, 4);
  const month = new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { month: "long" });
  return `${month} ${year}`;
}

function formatPeriodSublabel(period) {
  if (period.start_date && period.end_date) {
    return `${period.start_date} → ${period.end_date}`;
  }
  return "";
}

export default function PayPeriodSelect({
  value,
  onChange,
  label = "Pay period",
  required = false,
  className = "",
  disabled = false,
  allowEmpty = true,
  emptyLabel = "Select pay period",
  hint = "",
}) {
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    listPayPeriods()
      .then((res) => {
        if (!cancelled) setPeriods(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setPeriods([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const options = useMemo(() => {
    const sorted = [...periods].sort((a, b) =>
      String(b.start_date || "").localeCompare(String(a.start_date || ""))
    );
    return sorted.map((p) => {
      const pst = periodStatusBadge(p.status);
      return {
        value: p.pay_period_id,
        label: formatPayPeriodLabel(p),
        sublabel: formatPeriodSublabel(p),
        group: periodGroup(p),
        badge: { label: pst.label, className: pst.className },
        period: p,
      };
    });
  }, [periods]);

  if (!loading && periods.length === 0) {
    return (
      <div className={className}>
        {label ? (
          <label className="hr-search-select-label">
            {label}
            {required ? " *" : ""}
          </label>
        ) : null}
        <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-xl p-3">
          No pay periods found. Create one from Pay Periods first.
        </p>
      </div>
    );
  }

  return (
    <SearchableSelect
      className={className}
      label={label}
      required={required}
      disabled={disabled}
      loading={loading}
      allowEmpty={allowEmpty}
      emptyLabel={emptyLabel}
      searchPlaceholder="Search by date or status…"
      hint={hint}
      value={value}
      options={options}
      onChange={(id, opt) => onChange(id, opt?.period || null)}
      noResultsText="No pay periods match your search"
    />
  );
}
